import { Link } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import Dropzone from "react-dropzone";
import useFileUploader from "./useFileUploader";
import { showToast } from "../../redux/slices/Toasts";
import { useAppDispatch } from "../../redux/hooks";
import { useEffect, useState } from "react";

export type FileType = File & {
    preview?: string;
    formattedSize?: string;
};

type FileUploaderProps = {
    onFileUpload?: (files: FileType[]) => void;
    showPreview?: boolean;
    fileName?: string;
    fileSize?: string;
    fileDetails?: (files: any) => void;
    updateFileDetails?(): void;
    onClose?(): void;
};

const FileUploader = ({ showPreview = true, onFileUpload, fileName, fileSize, fileDetails, updateFileDetails, onClose }: FileUploaderProps) => {
    const dispatch = useAppDispatch();
    const { selectedFiles, handleAcceptedFiles, removeFile } = useFileUploader(showPreview);
    const [displayFile, setDisplayFile] = useState(false);
    const [selectedFilesCounter, setSelectedFilesCounter] = useState(0);

    useEffect(() => {
        if (fileName !== "") setDisplayFile(true);
    }, [fileName]);

    useEffect(() => setSelectedFilesCounter(selectedFiles.length), [selectedFiles.length]);

    function handleClose(){
        onClose && onClose();
        setDisplayFile(false);
        setSelectedFilesCounter(0);
        if(updateFileDetails) updateFileDetails();
    }

    return (
        <>
            {fileName && displayFile ? (
                <Card className="mt-1 mb-0 shadow-none border">
                    <div className="p-2">
                        <Row className="align-items-center">
                            <Col className="ps-0 ms-3">
                                <Link to="#" className="text-muted fw-bold">{fileName}</Link>
                                <p className="mb-0"><strong>{fileSize}</strong></p>
                            </Col>
                            <Col className="text-end">
                                <Link to="#" className="btn btn-link btn-lg text-muted shadow-none"><i className="dripicons-cross" onClick={handleClose}></i></Link>
                            </Col>
                        </Row>
                    </div>
                </Card>
            ) : (
                <>
                    {selectedFilesCounter === 0 &&
                        <Dropzone
                            onDrop={(acceptedFiles, fileRejections) => {
                                if (fileRejections.length > 0) {
                                    dispatch(showToast({ value: ["You can only upload one file at a time."] }));
                                } else {
                                    // @ts-ignore
                                    if(fileDetails) fileDetails(acceptedFiles);
                                    handleAcceptedFiles(acceptedFiles, onFileUpload);
                                    setDisplayFile(true);
                                }
                            }}
                            maxFiles={1}
                        >
                            {({ getRootProps, getInputProps }) => (
                                <div className="dropzone w-100 prevent-select d-flex flex-grow align-items-center justify-content-center">
                                    <div className="dz-message needsclick" {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        <i className="h2 text-muted dripicons-cloud-upload"></i>
                                        <h4>Drop file here or click to upload.</h4>
                                    </div>
                                </div>
                            )}
                        </Dropzone>
                    }
                    
                    {showPreview && selectedFilesCounter > 0 && (
                        <div className="dropzone-previews mt-3" id="uploadPreviewTemplate">
                            {(selectedFiles || []).map((f, i) => {
                                return (
                                    <Card className="mt-1 mb-0 shadow-none border" key={i + "-file"}>
                                        <div className="p-2">
                                            <Row className="align-items-center">
                                                <Col className="ps-0 ms-3">
                                                    <Link to="#" className="text-muted fw-bold">{f.name}</Link>
                                                    <p className="mb-0"><strong>{f.formattedSize}</strong></p>
                                                </Col>
                                                <Col className="text-end">
                                                    <Link to="#" className="btn btn-link btn-lg text-muted shadow-none"><i className="dripicons-cross" onClick={() => removeFile(f)}></i></Link>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Card>
                                );
                            })}
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export { FileUploader };
